import { render, staticRenderFns } from "./CreatePatientModal.vue?vue&type=template&id=3ed192f1&"
import script from "./CreatePatientModal.vue?vue&type=script&lang=js&"
export * from "./CreatePatientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports